import { SupportRequestBackendClient } from '@naus-code/naus-admin-types';
import { useSupportRequestStore } from './supportRequest.store';

export const useGetSupportItemAdminUser = (
  supportRequest: SupportRequestBackendClient,
) => {
  const isFromNewSupportList = useSupportRequestStore((state) => state.isFromNew);

  return isFromNewSupportList
    ? supportRequest._adminUserIdSupervisor
    : supportRequest._adminUserId;
};
